<div *ngIf="isLoading" class="m-auto">
    <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
    </mat-progress-spinner>
</div>
<div class="empresa-tab" *ngIf="!isLoading">
    <form class="form" role="form" autocomplete="off" [formGroup]="empresaForm">
        <div class="w-75">
            <div class="block-looper" *ngIf="checkPermisionVisibility('18')">
                <h2>Empresa</h2>
                <div class="form-wrap-full">
                    <div class="form-wrap long-field">
                        <mat-label class="label">Nombre</mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" formControlName="Nombre" />
                        </mat-form-field>
                    </div>
                    <div class="form-wrap long-field">
                        <mat-label class="label">Nombre legal
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('NombreLegal')">R</button>
                        </mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" formControlName="NombreLegal" />
                        </mat-form-field>
                    </div>
                    <div class="form-wrap short-field">
                        <mat-label class="label">Abreviacion</mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" formControlName="Abreviacion" />
                        </mat-form-field>
                    </div>
                    <div class="form-wrap long-field">
                        <mat-label class="label">Proyecto
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('Proyecto')">R</button>
                        </mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" formControlName="Proyecto" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-wrap-full">
                    <div class="form-wrap short-field">
                        <mat-label class="label">NIF</mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" formControlName="NIF" />
                        </mat-form-field>
                    </div>
                    <div class="form-wrap long-field" *ngIf="checkPermisionVisibility('18')">
                        <mat-label class="label">Dirección</mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" formControlName="Direccion" />
                        </mat-form-field>
                    </div>
                    <div class="form-wrap short-field">
                        <mat-label class="label">CP</mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" maxlength="5" formControlName="CP" />
                        </mat-form-field>
                        <mat-error class="fix-err"
                            *ngIf="empresaForm.get('CP').invalid && empresaForm.get('CP').touched">
                            <span
                                *ngIf="empresaForm.get('CP').errors.NotAPostalCode || empresaForm.get('CP').errors.pattern">
                                Se requieren 5 dígitos
                            </span>
                        </mat-error>
                    </div>
                    <div class="form-wrap short-field" *ngIf="checkPermisionVisibility('18')">
                        <mat-label class="label">Población</mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" formControlName="Poblacion" />
                        </mat-form-field>
                    </div>
                    <div class="form-wrap short2-field" *ngIf="checkPermisionVisibility('18')">
                        <mat-label class="label">Provincia</mat-label>
                        <mat-form-field appearance="fill" [matTooltip]="getProvinciaTooltip()" matTooltipPosition="below">
                            <mat-select placeholder="" formControlName="Provincia">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="
                                        let province of _direccionService.ProvinceList
                                    " [value]="province.value">
                                    {{ province.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-wrap short-field" *ngIf="checkPermisionVisibility('18')">
                        <mat-label class="label">Teléfono</mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" formControlName="Telefono1" />
                        </mat-form-field>
                    </div>
                    <div class="form-wrap short-field" *ngIf="checkPermisionVisibility('18')">
                        <mat-label class="label">Fax</mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="text" matInput placeholder="" formControlName="Fax" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-wrap-full">
                    <div class="form-wrap exlong-field" *ngIf="checkPermisionVisibility('18')">
                        <mat-label class="label">Email de envio
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('EmailEnvio')">R</button>
                        </mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="email" matInput placeholder="" formControlName="EmailEnvio" />
                        </mat-form-field>
                        <mat-error
                            *ngIf="empresaForm.get('EmailEnvio').invalid && empresaForm.get('EmailEnvio').touched">
                            <span *ngIf="empresaForm.get('EmailEnvio').hasError('email')">
                                Correo electrónico no válido
                            </span>
                        </mat-error>
                    </div>
                    <div class="form-wrap exlong-field" *ngIf="checkPermisionVisibility('18')">
                        <mat-label class="label">Email de copia
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('CopiaEnvio')">R</button>
                        </mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="email" matInput placeholder="" formControlName="CopiaEnvio" />
                        </mat-form-field>
                        <mat-error
                            *ngIf="empresaForm.get('CopiaEnvio').invalid && empresaForm.get('CopiaEnvio').touched">
                            <span *ngIf="empresaForm.get('CopiaEnvio').hasError('email')">
                                Correo electrónico no válido
                            </span>
                        </mat-error>
                    </div>
                    <div class="form-wrap exlong-field">
                        <mat-label class="label">Email de partes
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('EmailParte')">R</button>
                        </mat-label>
                        <mat-form-field class="full-width" appearance="fill">
                            <input type="email" matInput placeholder="" formControlName="EmailParte" />
                        </mat-form-field>
                        <mat-error
                            *ngIf="empresaForm.get('EmailParte').invalid && empresaForm.get('EmailParte').touched">
                            <span *ngIf="empresaForm.get('EmailParte').hasError('email')">
                                Correo electrónico no válido
                            </span>
                        </mat-error>
                    </div>
                </div>
            </div>

                <div class="block-looper" *ngIf="checkPermisionVisibility('18')">
                    <h2>Datos adicionales</h2>
                    <div class="form-wrap normal-field">
                        <mat-label class="below">Tipo</mat-label>
                        <mat-form-field appearance="fill" [matTooltip]="getTipoTooltip()" matTooltipPosition="below">
                        <mat-select placeholder="" formControlName="Tipo">
                            <mat-option value="">Seleccione</mat-option>
                            <mat-option *ngFor="let type of _empresaService.tipoList" [value]="type.value">
                            {{ type.viewValue }}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                </div>
                <div class="form-wrap">
                    <mat-label class="label">Sector</mat-label>
                    <mat-form-field appearance="fill" 
                                    [matTooltip]="getSectorTooltip()" 
                                    matTooltipPosition="below">
                        <mat-select placeholder="Seleccione" formControlName="Sector" 
                                    (selectionChange)="onSectorChange($event.source.triggerValue)">
                        <mat-option value="">Seleccione</mat-option>
                        <mat-option *ngFor="let sector of _empresaService.sectorList" [value]="sector.viewValue">
                            {{ sector.viewValue }}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                    </div>

                <!-- Selección de CNAE -->
                <div class="form-wrap">
                    <mat-label class="label">CNAE</mat-label>
                    <mat-form-field appearance="fill" [matTooltip]="getCNAETooltip()" matTooltipPosition="below">
                        <mat-select placeholder="Seleccione" formControlName="CNAE">
                            <mat-option>Seleccione</mat-option>
                            <mat-option *ngFor="let cnae of cnaeList" [value]="cnae.value">
                             {{ cnae.value }} - {{cnae.stringValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="form-wrap">
                    <mat-label class="label">Mutua
                        <button *ngIf="checkPermisionVisibility('38')" (click)="AddRepercutirFields('Mutua')">R</button>
                    </mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input type="text" matInput placeholder="" formControlName="Mutua" />
                    </mat-form-field>
                </div>
                <div class="form-wrap">
                    <mat-label class="label">Contingencias Comunes
                        <button *ngIf="checkPermisionVisibility('38')"
                            (click)="AddRepercutirFields('ContingenciasComunes')">R</button>
                    </mat-label>
                    <mat-form-field appearance="fill">
                        <mat-select placeholder="" formControlName="ContingenciasComunes">
                            <mat-option>Seleccione</mat-option>
                            <mat-option *ngFor="
                                    let contingenciasComunes of _empresaService.contingenciasComunesList
                                " [value]="contingenciasComunes.value">
                                {{ contingenciasComunes.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-wrap">
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox formControlName="ImportePorObjetivo" class="checked83">Importe por objetivos
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="w-25 f-r">
            <div class="block-looper block-looper-half-right">
                <div class="block-looper-half-wrapper">
                    <h2>Adjuntos <button [disabled]="!isEdit" (click)="CreateCompany()">
                            <mat-icon>add</mat-icon>
                        </button></h2>
                    <div class="attach-company-tbl">
                        <table mat-table [dataSource]="adjuntoDataSource" class="tr-small">
                            <caption></caption>
                            <ng-container matColumnDef="company">
                                <th mat-header-cell *matHeaderCellDef> Nombre </th>
                                <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                            </ng-container>

                            <ng-container matColumnDef="option">
                                <th mat-header-cell *matHeaderCellDef> &nbsp; </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button color="primary" aria-label="Delete" [disabled]="!isEdit"
                                        (click)="DeleteCompany(element)">
                                        <mat-icon>delete_forever</mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="adjuntoColumn; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: adjuntoColumn;"
                                [ngClass]="{'cusDisable': !isEdit}">
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="block-looper" *ngIf="checkPermisionVisibility('19')">
            <div class="w-65">
                <h2>Datos de control</h2>
                <div class="form-wrap">
                    <mat-label class="label">Calendario laboral
                        <button *ngIf="checkPermisionVisibility('38')"
                            (click)="AddRepercutirFields('CalendarioLaboral')">R</button>
                    </mat-label>
                    <mat-form-field appearance="fill" 
                                    [matTooltip]="getCalendarioLaboralTooltip()" 
                                    matTooltipPosition="below">
                        <mat-select placeholder="" formControlName="CalendarioLaboral">
                            <mat-option>Seleccione</mat-option>
                            <mat-option *ngFor="let ccaa of dropDownList.ccaa" [value]="ccaa.poblacion">
                                {{ ccaa.poblacion }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-wrap date-field">
                    <mat-label class="label">F. Inicio Gestión
                        <button *ngIf="checkPermisionVisibility('38')"
                            (click)="AddRepercutirFields('InicioGestion')">R</button>
                    </mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput [matDatepicker]="Inicio" formControlName="InicioGestion" />
                        <mat-datepicker-toggle matSuffix [for]="Inicio"></mat-datepicker-toggle>
                        <mat-datepicker #Inicio></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="form-wrap date-field">
                    <mat-label class="label">F. Fin Gestión
                        <button *ngIf="checkPermisionVisibility('38')"
                            (click)="AddRepercutirFields('FinGestion')">R</button>
                    </mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput [matDatepicker]="Fin" formControlName="FinGestion" />
                        <mat-datepicker-toggle matSuffix [for]="Fin"></mat-datepicker-toggle>
                        <mat-datepicker #Fin></mat-datepicker>
                    </mat-form-field>
                    <mat-error class="fix-err-date"
                        *ngIf="empresaForm.get('FinGestion').invalid && empresaForm.get('FinGestion').touched">
                        <span *ngIf="empresaForm.get('FinGestion').hasError('invalidDate')" class="validation-span">
                            Las fechas están invertidas
                        </span>
                    </mat-error>
                </div>
                <div class="form-wrap">
                    <mat-label class="label">Primer contacto
                        <button *ngIf="checkPermisionVisibility('38')"
                            (click)="AddRepercutirFields('PrimerContacto')">R</button>
                    </mat-label>
                    <mat-form-field appearance="fill" 
                                    [matTooltip]="getPrimerContactoTooltip()" 
                                    matTooltipPosition="below">
                        <mat-select placeholder="" formControlName="PrimerContacto">
                            <mat-option>Seleccione</mat-option>
                            <mat-option *ngFor="let doctor of dropDownList.activeDoctors" [value]="doctor.value">
                                {{ doctor.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-wrap">
                    <mat-label class="label">Médico visitador
                        <button *ngIf="checkPermisionVisibility('38')"
                            (click)="AddRepercutirFields('MedicoId')">R</button>
                    </mat-label>
                    <mat-form-field appearance="fill"
                                    [matTooltip]="getMedicoVisitadorTooltip()" 
                                    matTooltipPosition="below">
                        <mat-select panelClass="cus-search-select" formControlName="MedicoId">
                            <input type="text" autocomplete="off" matInput placeholder="búsqueda" #medicoSelect
                                (input)="SearchDoctors()" />
                            <mat-option>Seleccione</mat-option>
                            <div class="search-options">
                                <mat-option *ngFor="let doctor of _medicoList" [value]="doctor.value">
                                    {{ doctor.viewValue }}
                                </mat-option>
                            </div>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-wrap-full" *ngIf="checkPermisionVisibility('21')">
                    <div class="form-wrap checkbox-view auto-field">
                        <mat-checkbox class="checked1" formControlName="CitacionFormal">Citación burofax
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('CitacionFormal')">R</button>
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view auto-field" *ngIf="checkPermisionVisibility('21')">
                        <mat-checkbox class="checked2" formControlName="CitacionSMS" (change)="DisableSms('sms')">Citación SMS
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('CitacionSMS')">R</button>
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view auto-field" *ngIf="checkPermisionVisibility('21')">
                        <mat-checkbox class="checked2" formControlName="CitacionSMSCert" (change)="DisableSms('cert')">Citación SMS certificado
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('CitacionSMSCert')">R</button>
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap medium-field" *ngIf="checkPermisionVisibility('21')">
                        <mat-label class="label">Plantilla Citación
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('CitPlantilla')">R</button>
                        </mat-label>
                        <mat-form-field appearance="fill" 
                                        [matTooltip]="getPlantillaCitacionTooltip()" 
                                        matTooltipPosition="below">
                            <mat-select placeholder="" formControlName="CitPlantilla">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let plantillaCitacion of dropDownList.plantillaCitacions"
                                            [value]="plantillaCitacion.viewValue">
                                {{ plantillaCitacion.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-wrap">
                        <mat-label class="label">Plantilla Carta PD
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('CartaPD')">R</button>
                        </mat-label>
                        <mat-form-field appearance="fill" 
                                        [matTooltip]="getPlantillaCartaPDTooltip()" 
                                        matTooltipPosition="below">
                            <mat-select placeholder="" formControlName="CartaPD">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let plantillaLOPD of dropDownList.plantillaLOPDs"
                                    [value]="plantillaLOPD.viewValue">
                                    {{ plantillaLOPD.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="form-wrap" *ngIf="checkPermisionVisibility('21')">
                        <mat-label class="label">Idioma SMS
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('IdiomaSms')">R</button>
                        </mat-label>
                        <mat-form-field appearance="fill" 
                                        [matTooltip]="getIdiomaSmsTooltip()" 
                                        matTooltipPosition="below">
                            <mat-select placeholder="" formControlName="IdiomaSms">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let idiomaSms of dropDownList.idiomaSms"
                                    [value]="idiomaSms.viewValue">
                                    {{ idiomaSms.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <h3>Cáculo de costes</h3>
                <div class="form-wrap">
                    <mat-label class="label">Convenio
                        <button *ngIf="checkPermisionVisibility('38')"
                            (click)="AddRepercutirFields('ConvenioId')">R</button>
                    </mat-label>
                    <mat-form-field appearance="fill" class="multi-select-group" 
                                    [matTooltip]="getConvenioTooltip()" 
                                    matTooltipPosition="below">
                        <mat-select formControlName="ConvenioId">
                            <mat-option>Seleccione</mat-option>
                            <mat-optgroup *ngFor="let group of dropDownList.convenios" [label]="group.name">
                                <mat-option *ngFor="let convenio of group.data" [value]="convenio.convenioId">
                                    {{convenio.nombre}}</mat-option>
                            </mat-optgroup>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-wrap short-field">
                    <mat-label class="label">Salario bruto
                        <button *ngIf="checkPermisionVisibility('38')"
                            (click)="AddRepercutirFields('SalarioBruto')">R</button>
                    </mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input type="text" class="curr" matInput placeholder="" formControlName="SalarioBruto"
                            appSpanishNumber>
                        <span matSuffix>&nbsp; €</span>
                    </mat-form-field>
                    <mat-error class="fix-err"
                        *ngIf="empresaForm.get('SalarioBruto').invalid && empresaForm.get('SalarioBruto').touched">
                        <span *ngIf="empresaForm.get('SalarioBruto').errors.hasTwoDecimalPlaces">
                            Invalido formato
                        </span>
                    </mat-error>
                </div>
                <div class="form-wrap">
                    <mat-label class="label">Contingencias profesionales
                        <button *ngIf="checkPermisionVisibility('38')"
                            (click)="AddRepercutirFields('ContingenciasProfesionales')">R</button>
                    </mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input type="text" matInput placeholder="" formControlName="ContingenciasProfesionales"
                            appSpanishNumber />
                    </mat-form-field>
                    <mat-error class="fix-err"
                        *ngIf="empresaForm.get('ContingenciasProfesionales').invalid && empresaForm.get('ContingenciasProfesionales').touched">
                        <span *ngIf="empresaForm.get('ContingenciasProfesionales').errors.hasTwoDecimalPlaces">
                            Invalido formato
                        </span>
                    </mat-error>
                </div>
            </div>
            <div class="w-35">
                <div class="f-r">
                    <h2>&nbsp;</h2>
                    <h3>Opciones de gestión</h3>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked3" formControlName="CalcularAbsentismo">Calcular absentismo
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked4" formControlName="CuadroMando">Cuadro de Mando</mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked5" formControlName="Duplicidad">Duplicidad</mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked6" formControlName="Movilidad">Movilidad</mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked7" formControlName="Revisar">Revisar
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('Revisar')">R</button>
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked8" formControlName="TieneTrabajadores">Puede tener trabajadores
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked9" formControlName="Facturacion">Totalizar facturación
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked10" formControlName="VisitaEmpresa">Visitas de Empresa
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <div class="block-looper" *ngIf="checkPermisionVisibility('19')">
            <div class="w-75">
                <h2>Datos heredados</h2>
                <div class="form-wrap checkbox-view auto-field p-r-15">
                    <mat-checkbox class="checked11" formControlName="ParentControl"
                        (change)="EnableOrDisableParentControlFormFields($event)">
                        <strong>Heredad campos de control</strong>
                    </mat-checkbox>
                </div>
            </div>
            <div formGroupName="DatosHeredados">
                <div class="w-65">
                    <div class="form-wrap">
                        <mat-label class="label">Administrativa</mat-label>
                        <mat-form-field appearance="fill" 
                                        [matTooltip]="getAdministrativaTooltip()" 
                                        matTooltipPosition="below">
                        <mat-select placeholder="" formControlName="Administrativa">
                            <mat-option>Seleccione</mat-option>
                            <mat-option *ngFor="let user of dropDownList.activeUsers" [value]="user.stringValue">
                            {{ user.viewValue }}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-wrap">
                        <mat-label class="label">Coordinador</mat-label>
                        <mat-form-field appearance="fill">
                            <mat-select placeholder="" formControlName="Coordinador">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let coordinator of dropDownList.coordinators"
                                    [value]="coordinator.viewValue">
                                    {{ coordinator.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="form-wrap">
                        <mat-label class="label">Tarea baja nueva</mat-label>
                        <mat-form-field appearance="fill" 
                                        [matTooltip]="getTareaBajaNuevaTooltip()" 
                                        matTooltipPosition="below">
                            <mat-select placeholder="" formControlName="BajaNueva">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let bajaNueva of _empresaService.bajaNuevaList"
                                    [value]="bajaNueva.value">
                                    {{ bajaNueva.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <h3>Campos en trabajador/baja</h3>
                    <div class="form-wrap multi-fiels">
                        <mat-label class="label">Tipos de baja</mat-label>
                        <mat-form-field appearance="fill">
                            <mat-select multiple placeholder="" formControlName="TiposBaja">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let leave of _empresaService.leaveTypeList" [value]="leave.value">
                                    {{ leave.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-wrap multi-fiels">
                        <mat-label class="label">Tipos de baja sin gestión</mat-label>
                        <mat-form-field appearance="fill">
                            <mat-select multiple placeholder="" formControlName="TiposSinGestion">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let leave of _empresaService.leaveTypeList" [value]="leave.value">
                                    {{ leave.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="form-wrap">
                        <mat-label class="label">Tipo de diagnóstico
                            <button *ngIf="checkPermisionVisibility('38')"
                                (click)="AddRepercutirFields('TipoDiagnostico')">R</button>
                        </mat-label>
                        <mat-form-field appearance="fill" class="full-width">
                            <mat-select formControlName="TipoDiagnostico" placeholder="Seleccione un tipo de diagnóstico">
                                <mat-option *ngFor="let tipoDiagnostico of _empresaService.tipoDiagnosticoList" [value]="tipoDiagnostico.value"> {{ tipoDiagnostico.viewValue }} </mat-option>
                            </mat-select>

                            <mat-error class="fix-err" 
                                        *ngIf="empresaForm.get('TipoDiagnostico')?.invalid && empresaForm.get('TipoDiagnostico')?.touched">
                                <span *ngIf="empresaForm.get('TipoDiagnostico')?.errors?.required">
                                Seleccione un tipo de diagnóstico
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div class="form-wrap">
                        <mat-label class="label">Tarifa indisposición</mat-label>
                        <mat-form-field appearance="fill">
                            <mat-select placeholder="" formControlName="TarifaIndisposicion">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let tarifaIndisposicion of _empresaService.tarifaIndisposicionList"
                                    [value]="tarifaIndisposicion.value">
                                    {{ tarifaIndisposicion.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="form-wrap">
                        <mat-label class="label">F. Antigüedad</mat-label>
                        <mat-form-field appearance="fill">
                            <mat-select placeholder="" formControlName="Fantiguedad">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let fAntiguedad of _empresaService.fAntiguedadList"
                                    [(value)]="fAntiguedad.value">
                                    {{fAntiguedad.viewValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                    </div>
                    <div class="form-wrap-full">
                        <div class="form-wrap xs-field">
                            <mat-label class="label">Días – No permitir tarea</mat-label>
                            <mat-form-field class="full-width" appearance="fill">
                                <input type="text" formControlName="DiasImpedirTareas" matInput placeholder="">
                            </mat-form-field>
                            <mat-error class="fix-err"
                                *ngIf="datosForm.get('DiasImpedirTareas').invalid && datosForm.get('DiasImpedirTareas').touched">
                                <span *ngIf="datosForm.get('DiasImpedirTareas').hasError('min')">
                                    No se aceptan valores negativos
                                </span>
                            </mat-error>
                            <mat-error class="fix-err"
                                *ngIf="datosForm.get('DiasImpedirTareas').invalid && datosForm.get('DiasImpedirTareas').touched">
                                <span *ngIf="datosForm.get('DiasImpedirTareas').hasError('max')">
                                    Máximo 512 días
                                </span>
                            </mat-error>
                        </div>
                    </div>

                </div>
                <div class="w-35">
                    <h3>Opciones de gestión</h3>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked15" formControlName="TipoBorrado">Consentimiento firmado
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked16" formControlName="ControlAcumulaciones">Control de
                            acumulaciones
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked17" formControlName="ComentarioParaEmpresa">Comentario para
                            empresa
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked12" formControlName="FfinContrato">F. Fin Contrato
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked18" formControlName="ImprimirNombreLegalEnTareas">Imprimir
                            nombre
                            legal
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked19" formControlName="ObligarCitacionTelefonica">Obligar citación
                            telefónica</mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked20" formControlName="PAMEM">PAMEM</mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked21" formControlName="PES">PES</mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked13" formControlName="ReferenciaBaja">Referencia Baja
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked14" formControlName="RefTrabajador">Referencia Trabajador
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked22" formControlName="ReclamarSolicitud">Reclamar solicitudes
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked23" formControlName="SabadoLaborable">Sábado laborable
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked24" formControlName="SeguimientoPostCitacion">Seguimiento
                            post-citación
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked25" formControlName="SinDatosMedicos">Sin datos médicos
                        </mat-checkbox>
                    </div>
                    <div class="form-wrap checkbox-view half-field">
                        <mat-checkbox class="checked26" formControlName="TieneSME">Tiene SME</mat-checkbox>
                    </div>
                </div>
            </div>

        </div>
        <div class="block-looper ficha" *ngIf="checkPermisionVisibility('20')">
            <h2>Ficha</h2>

            <div class="w-65">
                <div class="form-wrap full-field">
                    <mat-label class="label">Actividad fuera de contrato</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <textarea matInput placeholder="" rows="3" formControlName="ActividadFueraContrato"></textarea>
                    </mat-form-field>
                </div>
                <div class="form-wrap full-field">
                    <mat-label class="label">Observaciones de la actividad</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <textarea matInput placeholder="" rows="3" formControlName="ObsActividad"></textarea>
                    </mat-form-field>
                </div>
            </div>

            <div class="w-35">



                <h3>Tipología de la empresa</h3>
                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked27" formControlName="GestionIT">Gestión IT</mat-checkbox>
                </div>
                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked28" formControlName="VisitasDomiciliarias">Visitas domiciliarias
                    </mat-checkbox>
                </div>
                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked29" formControlName="Asistencial">Asistencial</mat-checkbox>
                </div>
                <h3>Actividad presencial</h3>

                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked32" formControlName="NoPasanTodasBajas">No todas las bajas
                    </mat-checkbox>
                </div>
                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked33" formControlName="ComunicaPostBaja">CC posterior al alta
                    </mat-checkbox>
                </div>
                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked34" formControlName="AbsentismoBajo">Absentismo bajo</mat-checkbox>
                </div>
                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked35" formControlName="DispersionGeografica">Dispersión geográfica
                    </mat-checkbox>
                </div>



                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked30" (change)="CheckBoxChange('ActividadPresencialNormal')"
                        formControlName="ActividadPresencialNormal">Exigen absentismo y tenemos medios</mat-checkbox>
                </div>
                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked31" (change)="CheckBoxChange('ActividadPresencialBaja')"
                        formControlName="ActividadPresencialBaja">Exigen absentismo y no podemos cumplir</mat-checkbox>
                </div>
                <div class="form-wrap checkbox-view half-field">
                    <mat-checkbox class="checked36" (change)="CheckBoxChange('CasosPuntuales')"
                        formControlName="CasosPuntuales">
                        Casos puntuales</mat-checkbox>
                </div>

            </div>
        </div>
        <div class="block-looper" *ngIf="checkPermisionVisibility('36')">
            <h2>Facturación</h2>
            <div class="form-wrap mid-field">
                <mat-label class="label">Nombre</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" matInput placeholder="" formControlName="Fenombre" />
                </mat-form-field>
            </div>
            <div class="form-wrap auto-field">
                <button mat-button mat-raised-button color="primary" (click)="CopyEmpresaValues()"
                    [disabled]="empresaForm.get('Fenombre').disabled" class="save">
                    Mismos datos
                </button>
            </div>
            <div class="form-wrap mid-field">
                <mat-label class="label">Persona de contacto</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" matInput placeholder="" formControlName="FepersonaContacto" />
                </mat-form-field>
            </div>
            <div class="form-wrap short-field">
                <mat-label class="label">Teléfono</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" matInput placeholder="" formControlName="Fetelefono" />
                </mat-form-field>
            </div>
            <div class="form-wrap">
                <mat-label class="label">Dirección</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" matInput placeholder="" formControlName="Fedireccion" />
                </mat-form-field>
            </div>
            <div class="form-wrap short-field">
                <mat-label class="label">Población</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" matInput placeholder="" formControlName="Fepoblacion" />
                </mat-form-field>
            </div>
            <div class="form-wrap small-field">
                <mat-label class="label">CP</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" matInput placeholder="" formControlName="Fecp" />
                </mat-form-field>
            </div>

            <div class="form-wrap-full">
                <div class="form-wrap checkbox-view auto-field auto-width">
                    <mat-checkbox class="checked37" formControlName="Fevariable">Importe Variable</mat-checkbox>
                </div>
                <div class="form-wrap checkbox-view auto-field auto-width">
                    <mat-checkbox class="checked38" formControlName="Fefijo">Importe fijo</mat-checkbox>
                </div>
                <div class="form-wrap small-field">
                    <mat-label class="label">&nbsp;</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input type="text" class="curr" formControlName="Feimporte" matInput placeholder=""
                            appSpanishNumber />
                        <span matSuffix>&nbsp; €</span>
                    </mat-form-field>
                    <mat-error class="fix-err"
                        *ngIf="empresaForm.get('Feimporte').invalid && empresaForm.get('Feimporte').touched">
                        <span *ngIf="empresaForm.get('Feimporte').errors.hasTwoDecimalPlaces">
                            Invalido formato
                        </span>
                    </mat-error>
                </div>
                <div class="form-wrap short-field">
                    <mat-label class="label">Periodicidad</mat-label>
                    <mat-form-field appearance="fill">
                        <mat-select placeholder="" formControlName="Feperiodicidad">
                            <mat-option>Seleccione</mat-option>
                            <mat-option *ngFor="
                                        let periodicidad of _empresaService.periodicidadList
                                    " [value]="periodicidad.value">
                                {{ periodicidad.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-wrap short-field">
                    <mat-label class="label">Fecha de pago</mat-label>
                    <mat-form-field appearance="fill">
                        <mat-select placeholder="" formControlName="FefechaPago">
                            <mat-option>Seleccione</mat-option>
                            <mat-option *ngFor="let fechaDePago of _empresaService.fechaDePagoList"
                                [value]="fechaDePago.value">
                                {{ fechaDePago.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="form-wrap small-field">
                    <mat-label class="label">Día de pago</mat-label>
                    <mat-form-field class="full-width" appearance="fill">
                        <input type="number" formControlName="FediaPago" matInput placeholder="" />
                    </mat-form-field>
                    <mat-error class="fix-err"
                        *ngIf="empresaForm.get('FediaPago').invalid && empresaForm.get('FediaPago').touched">
                        <span *ngIf="empresaForm.get('FediaPago').hasError('min')">
                            No se aceptan valores negativos
                        </span>
                    </mat-error>
                    <mat-error class="fix-err"
                        *ngIf="empresaForm.get('FediaPago').invalid && empresaForm.get('FediaPago').touched">
                        <span *ngIf="empresaForm.get('FediaPago').hasError('max')">
                            Máximo 30 días
                        </span>
                    </mat-error>
                </div>
            </div>
            <div class="form-wrap short-field">
                <mat-label class="label">Código contable</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" formControlName="FecodContable" matInput placeholder="" />
                </mat-form-field>
            </div>
            <div class="form-wrap short-field">
                <mat-label class="label">Código analítico</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" formControlName="FecodAnalitico" matInput placeholder="" />
                </mat-form-field>
            </div>

            <div class="form-wrap">
                <mat-label class="label">Destinatario</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" formControlName="Fedestinatario" matInput placeholder="" />
                </mat-form-field>
            </div>
            <div class="form-wrap mid-field four-dig">
                <mat-label class="label">Cuenta corriente</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" formControlName="Feccentidad" maxlength="4" matInput placeholder="" />
                </mat-form-field>
                <mat-error *ngIf="empresaForm.get('Feccentidad').invalid && empresaForm.get('Feccentidad').touched">
                    <span *ngIf="empresaForm.get('Feccentidad').errors.exactLength ">
                        Se requieren 4 dígitos
                    </span>
                </mat-error>
            </div>
            <div class="form-wrap mid-field four-dig">
                <mat-label class="label">&nbsp;</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" formControlName="Feccsucursal" maxlength="4" matInput placeholder="" />
                </mat-form-field>
                <mat-error *ngIf="empresaForm.get('Feccsucursal').invalid && empresaForm.get('Feccsucursal').touched">
                    <span *ngIf="empresaForm.get('Feccsucursal').errors.exactLength ">
                        Se requieren 4 dígitos
                    </span>
                </mat-error>
            </div>
            <div class="form-wrap mid-field two-dig">
                <mat-label class="label">&nbsp;</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" formControlName="Feccdc" maxlength="2" matInput placeholder="" />
                </mat-form-field>
                <mat-error *ngIf="empresaForm.get('Feccdc').invalid && empresaForm.get('Feccdc').touched">
                    <span *ngIf="empresaForm.get('Feccdc').errors.exactLength ">
                        Se requieren 2 dígitos
                    </span>
                </mat-error>
            </div>
            <div class="form-wrap mid-field ten-dig">
                <mat-label class="label">&nbsp;</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" formControlName="Fecccuenta" maxlength="10" matInput placeholder="" />
                </mat-form-field>
                <mat-error *ngIf="empresaForm.get('Fecccuenta').invalid && empresaForm.get('Fecccuenta').touched">
                    <span *ngIf="empresaForm.get('Fecccuenta').errors.exactLength ">
                        Se requieren 10 dígitos
                    </span>
                </mat-error>
            </div>

            <div class="form-wrap full-field">
                <mat-label class="label">Criterios de facturación</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <textarea matInput formControlName="CriteriosFacturacion" placeholder="" rows="3"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="block-looper" *ngIf="checkPermisionVisibility('36')">
            <h2>Contrato</h2>
            <div class="form-wrap checkbox-view auto-field auto-width">
                <mat-checkbox formControlName="ContratoRealizado" class="checked39">Contrato Realizado
                </mat-checkbox>
            </div>
            <div class="form-wrap checkbox-view auto-field auto-width">
                <mat-checkbox formControlName="ContratoFirmado" class="checked40">Contrato firmado</mat-checkbox>
            </div>
            <div class="form-wrap date-field">
                <mat-label class="label">Fecha inicio contrato</mat-label>
                <mat-form-field appearance="fill">
                    <input matInput [matDatepicker]="Fecha" formControlName="FinicioContrato" />
                    <mat-datepicker-toggle matSuffix [for]="Fecha"></mat-datepicker-toggle>
                    <mat-datepicker #Fecha></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="form-wrap mid-field">
                <mat-label class="label">Duración</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" matInput placeholder="" formControlName="DuracionContrato" />
                </mat-form-field>
            </div>
            <div class="form-wrap date-field">
                <mat-label class="label">Fecha inicio facture</mat-label>
                <mat-form-field appearance="fill">
                    <input matInput [matDatepicker]="facture" formControlName="FinicioFra" />
                    <mat-datepicker-toggle matSuffix [for]="facture"></mat-datepicker-toggle>
                    <mat-datepicker #facture></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="form-wrap mid-field">
                <mat-label class="label">Prórroga</mat-label>
                <mat-form-field appearance="fill">
                    <mat-select placeholder="" formControlName="ProrrogaContrato">
                        <mat-option>Seleccione</mat-option>
                        <mat-option *ngFor="
                                    let prorrogaContrato of _empresaService.prorrogaContratoList
                                " [value]="prorrogaContrato.value">
                            {{ prorrogaContrato.viewValue }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="form-wrap date-field">
                <mat-label class="label">Fecha envío contrato</mat-label>
                <mat-form-field appearance="fill">
                    <input matInput [matDatepicker]="Fechaenvo" formControlName="FcontratoEnviado" (dateChange)="adjustDateEnv($event.value)"/>
                    <mat-datepicker-toggle matSuffix [for]="Fechaenvo"></mat-datepicker-toggle>
                    <mat-datepicker #Fechaenvo></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="form-wrap date-field">
                <mat-label class="label">F. recepción contrato</mat-label>
                <mat-form-field appearance="fill">
                    <input matInput [matDatepicker]="Fecharecepcion" formControlName="FcontratoRecibido" (dateChange)="adjustDateRec($event.value)" />
                    <mat-datepicker-toggle matSuffix [for]="Fecharecepcion"></mat-datepicker-toggle>
                    <mat-datepicker #Fecharecepcion></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="form-wrap mid-field">
                <mat-label class="label">Comercial</mat-label>
                <mat-form-field class="full-width" appearance="fill">
                    <input type="text" formControlName="Comercial" matInput placeholder="" />
                </mat-form-field>
            </div>
        </div>
        <div class="block-looper bottom-table" *ngIf="checkPermisionVisibility('23')">
            <h2>Envíos automáticos</h2>
            <h3>Listados</h3>
            <table ng-disabled="true">
                <caption></caption>
                <thead>
                    <tr>
                        <th>Listado</th>
                        <th>Enviar</th>
                        <th>Tipo</th>
                        <th>Formato</th>
                        <th>Email</th>
                        <th>Contraseña</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            Personal
                        </td>
                        <td>
                            <mat-checkbox formControlName="ListadoPersonal" class="checked39">
                            </mat-checkbox>
                        </td>
                        <td>
                        <mat-form-field appearance="fill" 
                                        [matTooltip]="getEnviosTipoTooltip('TipoListadoPersonal')" 
                                        matTooltipPosition="below">
                            <mat-select placeholder="" formControlName="TipoListadoPersonal">
                                <mat-option>Seleccione</mat-option>
                                <mat-option *ngFor="let report of dropDownList.reportTypes"
                                            [value]="report.stringValue">
                                    {{ report.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select placeholder="" formControlName="TipoFormatoPersonal">
                                    <mat-option *ngFor="let tipoFormatoPersonal of _empresaService.tipoFormato"
                                        [(value)]="tipoFormatoPersonal.value">
                                        {{tipoFormatoPersonal.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field class="full-width" appearance="fill">
                                <textarea type="email" matInput placeholder="" formControlName="DirPersonal"></textarea>
                            </mat-form-field>
                            <mat-error
                                *ngIf="empresaForm.get('DirPersonal').invalid && empresaForm.get('DirPersonal').touched">
                                <span *ngIf="empresaForm.get('DirPersonal').errors.whiteSpaces ">
                                    No se admiten espacios
                                </span>
                            </mat-error>
                        </td>
                        <td *ngIf="checkPermisionVisibility('8')">
                            <mat-form-field class="full-width" appearance="fill">
                                <input type="text" matInput placeholder="" formControlName="PasswordPersonal" />
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr>
                        <td>SME</td>
                        <td>
                            <mat-checkbox formControlName="ListadoSME" class="checked39">
                            </mat-checkbox>
                        </td>
                        <td>
                            <mat-form-field appearance="fill" 
                                            [matTooltip]="getEnviosTipoTooltip('TipoListadoSME')" 
                                            matTooltipPosition="below">
                                <mat-select placeholder="" formControlName="TipoListadoSME">
                                    <mat-option>Seleccione</mat-option>
                                    <mat-option *ngFor="let report of dropDownList.reportTypes"
                                                [value]="report.stringValue">
                                        {{ report.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                            <td>
                            <mat-form-field appearance="fill">
                                <mat-select placeholder="" formControlName="TipoFormatoSme">
                                    <mat-option *ngFor="let tipoFormatoSme of _empresaService.tipoFormato"
                                        [(value)]="tipoFormatoSme.value">
                                        {{tipoFormatoSme.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field class="full-width" appearance="fill">
                                <textarea type="email" matInput placeholder="" formControlName="DirSME"></textarea>
                            </mat-form-field>
                            <mat-error *ngIf="empresaForm.get('DirSME').invalid && empresaForm.get('DirSME').touched">
                                <span *ngIf="empresaForm.get('DirSME').errors.whiteSpaces ">
                                    No se admiten espacios
                                </span>
                            </mat-error>
                        </td>
                        <td *ngIf="checkPermisionVisibility('8')">
                            <mat-form-field class="full-width" appearance="fill">
                                <input type="text" matInput placeholder="" formControlName="PasswordSME" />
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr>
                        <td>Jefe de Area</td>
                        <td>
                            <mat-checkbox formControlName="ListadoJefe" class="checked39">
                            </mat-checkbox>
                        </td>
                        <td>
                            <mat-form-field appearance="fill"
                                            [matTooltip]="getEnviosTipoTooltip('TipoListadoJefe')"
                                            matTooltipPosition="below">
                                <mat-select placeholder="" formControlName="TipoListadoJefe">
                                    <mat-option>Seleccione</mat-option>
                                    <mat-option *ngFor="let report of dropDownList.reportTypes"
                                                [value]="report.stringValue">
                                        {{ report.viewValue }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field appearance="fill">
                                <mat-select placeholder="" formControlName="TipoFormatoJefe">
                                    <mat-option *ngFor="let tipoFormatoJefe of _empresaService.tipoFormato"
                                        [(value)]="tipoFormatoJefe.value">
                                        {{tipoFormatoJefe.viewValue}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field class="full-width" appearance="fill">
                                <textarea type="email" matInput placeholder="" formControlName="DirJefe"></textarea>
                            </mat-form-field>
                            <mat-error *ngIf="empresaForm.get('DirJefe').invalid && empresaForm.get('DirJefe').touched">
                                <span *ngIf="empresaForm.get('DirJefe').errors.whiteSpaces ">
                                    No se admiten espacios
                                </span>
                            </mat-error>
                        </td>
                        <td *ngIf="checkPermisionVisibility('8')">
                            <mat-form-field class="full-width" appearance="fill">
                                <input type="text" matInput placeholder="" formControlName="PasswordJefe" />
                            </mat-form-field>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="block-looper bottom-table-solicit" *ngIf="checkPermisionVisibility('23')">
            <h3>Solicitudes</h3>
            <table>
                <caption></caption>
                <thead>
                    <tr>
                        <th>Solicitud</th>
                        <th>Enviar</th>
                        <th>Email</th>
                        <th>Contraseña</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Alta</td>
                        <td>
                            <mat-checkbox formControlName="SolicitarAltas" class="checked39">
                            </mat-checkbox>
                        </td>
                        <td>
                            <mat-form-field class="full-width" appearance="fill">
                                <textarea type="email" matInput placeholder="" formControlName="EmailAltas"></textarea>
                            </mat-form-field>
                            <mat-error
                                *ngIf="empresaForm.get('EmailAltas').invalid && empresaForm.get('EmailAltas').touched">
                                <span *ngIf="empresaForm.get('EmailAltas').hasError('email')">
                                    Correo electrónico no válido
                                </span>
                            </mat-error>
                        </td>
                        <td *ngIf="checkPermisionVisibility('8')">
                            <mat-form-field class="full-width" appearance="fill">
                                <input type="text" matInput placeholder="" formControlName="PasswordAlta" />
                            </mat-form-field>
                        </td>
                    </tr>
                    <tr>
                        <td>Directiones</td>
                        <td>
                            <mat-checkbox formControlName="SolicitarDirecciones" class="checked39">
                            </mat-checkbox>
                        </td>

                    </tr>
                    <tr>
                        <td>Plantila</td>
                        <td>
                            <mat-checkbox formControlName="SolicitudPlantillas" class="checked39">
                            </mat-checkbox>
                        </td>
                        <td>
                            <mat-form-field class="full-width" appearance="fill">
                                <textarea type="email" matInput placeholder=""
                                    formControlName="EmailPlantillas"></textarea>
                            </mat-form-field>
                            <mat-error
                                *ngIf="empresaForm.get('EmailPlantillas').invalid && empresaForm.get('EmailPlantillas').touched">
                                <span *ngIf="empresaForm.get('EmailPlantillas').hasError('email')">
                                    Correo electrónico no válido
                                </span>
                            </mat-error>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="block-looper" *ngIf="checkPermisionVisibility('15')">
            <h2>Observaciones</h2>
            <div class="form-wrap full-field">
                <mat-form-field class="full-width" appearance="fill">
                    <textarea matInput placeholder="" formControlName="Observaciones" rows="9"></textarea>
                </mat-form-field>
            </div>
        </div> -->
    </form>

</div>